import Api from './api';

export interface DataRoomDTO {
    id: string;
    name: string;
    description: string;
    items: DocumentDTO[];
}

export interface DocumentDTO {
    id: string;
    name: string;
    description: string;
    createdAt: Date;
    updatedAt: Date;
    link: string;
    linkExpiration: Date;
}

export default class ApiDataRoom extends Api {
    public static getDataRoom(id: number): Promise<DataRoomDTO> {
        return this.axios.get(`/v1/data-rooms/${id}`, { cache: false }).then((res) => {
            return res.data;
        });
    }
}
